import React from "react";
import { useSelector } from "react-redux";
import classes from './AllTeams.module.css';
import Team from "./Team/Team";
import ScrollLTR from "../../../../lms-shared/UI/ScrollLTR";

const AllTeams = ({ data, addTeam, searchTerm, deleteTeam }) => {

    const { texts } = useSelector(state => state.translate);
    
    return (
        <div className={classes.AllTeams}>
            <div className={classes.Title}>{texts.teams}</div>
            <div className={classes.ListWrapper}>
                <ScrollLTR dropStyle={{ height: "calc(100% - 16px)", padding: "0 15px" }}>
                    <div className={classes.List}>
                        {Object.keys(data).map((listId) => (
                            <Team key={listId} listId={listId} items={data[listId]?.users} submissionStatus={data[listId].submissionStatus} searchTerm={searchTerm} deleteTeam={deleteTeam} />
                        ))}
                        <div className={classes.AddTeam} onClick={addTeam}></div>
                    </div>
                </ScrollLTR>
            </div>
            <div className={classes.AllTeamsNote}>{texts.allTeamsNote}</div>
        </div>
    )
}

export default AllTeams;